var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.297 63.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M48.581 45.234a9.473 9.473 0 0 0-6.348 2.474L19.141 34.375a10.436 10.436 0 0 0 .291-2.249 10.437 10.437 0 0 0-.291-2.249l22.833-13.2a9.6 9.6 0 1 0-3.109-7.036 10.436 10.436 0 0 0 .291 2.249l-22.833 13.2a9.638 9.638 0 1 0 0 14.071l23.06 13.365a8.994 8.994 0 0 0-.259 2.088 9.457 9.457 0 1 0 9.457-9.381Z",
    "data-name": "Icon material-share"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.40b69fb33e16e80ac83361fe1bb9474d.svg";
export { ForwardRef as ReactComponent };